const steps = [
  {
    icon: 'ri-fingerprint-line',
    title: '登录账号',
    desc: '注册并登录吃瓜大赛账号，这是领取免费票与参与打榜的基础。',
  },
  {
    icon: 'ri-fire-line',
    title: '找到心仪选手',
    desc: '进入实时排行榜或参赛看点，找到你想支持的选手并进入投票页。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '投票 + 拉票',
    desc: '投出每日免费票，并把专属海报链接分享给好友，邀请大家一起打榜。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '实时追踪排名',
    desc: '票数实时同步榜单，随时查看你的人气贡献与选手的排名走势。',
  },
];

const tips = [
  '每天签到打卡可额外领取助力票，别错过免费机会。',
  'PK 冲刺阶段最后 2 小时票数波动最大，建议提前布局。',
  '把拉票链接发到粉丝群并定时提醒，能显著提升票数转化。',
  '分享原创投票攻略，还能解锁专属打榜徽章与曝光位。',
  '关注官方公告，参与话题互动有机会获得翻倍助力票。',
];

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-sun-500 uppercase">
            <i className="ri-rocket-2-line"></i> Get Started
          </span>
          <h2 className="mt-3 font-display font-bold text-3xl md:text-5xl text-ink leading-tight">
            三步看懂，轻松为选手打榜助力
          </h2>
          <p className="mt-4 text-sm md:text-base text-ink/60 leading-relaxed">
            打榜并不复杂，从登录到投票全程免费。跟着下面的流程走，几分钟内就能为你支持的选手贡献人气，
            冲刺实时人气排行榜的前列。
          </p>

          <div className="mt-8 space-y-5">
            {steps.map((s, idx) => (
              <div key={idx} className="flex items-start gap-4">
                <div className="flex flex-col items-center">
                  <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-melon-500 to-melon-600 text-white flex items-center justify-center text-xl shrink-0">
                    <i className={s.icon}></i>
                  </span>
                  {idx < steps.length - 1 && <span className="w-px flex-1 bg-melon-100 my-1 min-h-6"></span>}
                </div>
                <div className="pt-1">
                  <h3 className="font-bold text-lg text-ink">
                    <span className="text-melon-500 mr-2">0{idx + 1}</span>
                    {s.title}
                  </h3>
                  <p className="mt-1 text-sm text-ink/60">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-3xl bg-canvas border border-melon-100 p-6 md:p-8">
          <div className="flex items-center gap-2 mb-5">
            <span className="w-10 h-10 rounded-xl bg-leaf-50 text-leaf-600 flex items-center justify-center text-xl">
              <i className="ri-lightbulb-flash-fill"></i>
            </span>
            <h3 className="font-display font-bold text-xl text-ink">助力小贴士</h3>
          </div>
          <ul className="space-y-3.5">
            {tips.map((t, idx) => (
              <li key={idx} className="flex items-start gap-3 text-sm md:text-base text-ink/75 leading-relaxed">
                <i className="ri-checkbox-circle-fill text-leaf-500 text-lg mt-0.5 shrink-0"></i>
                <span>{t}</span>
              </li>
            ))}
          </ul>

          <div className="mt-7 rounded-2xl bg-gradient-to-r from-leaf-500 to-leaf-400 text-white p-5 flex items-center gap-4">
            <i className="ri-trophy-line text-3xl"></i>
            <p className="text-sm md:text-base font-medium">
              每投出 1 票，你的头像就会点亮在选手的应援墙上。冲榜季结束，贡献榜前列的粉丝将获得专属荣誉徽章。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}